// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageHeadline_wrapper__UBKf1"};